export enum S3UploadStatus {
  COMPLETE = 'complete',
  PENDING = 'pending',
  FAILED = 'failed',
}
